import React, { useState, useEffect } from "react";
import Helmet from "react-helmet";
import { withTranslation } from "react-i18next";
import { Row, Col } from "react-bootstrap";
import moment from "moment";
//components
import { Content, EditContent } from "../../components/profile";
import { AlertMessage } from "../../components/common";
//style
import style from "../../components/profile/profile.module.scss";

//service
import ProfileService from "../../../service/profile";
import { withRouter } from "react-router-dom";
import companyName from "../../../store/mobxStore/companyName";
import { useHistory } from "react-router";
import Spinner from "../../shared/Spinner";
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";
import { CurrencyDecimalFormatNew } from "../../helper";

function RankIncentive({ t }) {
  let service = new ProfileService();
  let history = useHistory();

  const { currentTheme } = useSelector((state) => state.Theme);
  const Currency = useSelector((state) => state.curr);

  const [state, setState] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const getData = () => {
    setError(null);
    service.getIncentiveDetails().then((res) => {
      setLoading(true);
      console.log("res inside get incentive details", res);
      if (res.status) {
        setState(res.data);
        setLoading(false);
      } else {
        setLoading(false);
        setError(res.error.description ?? "Some Error Occured");
      }
    });
  };

  console.log(state, "state");
  useEffect(() => {
    getData();
  }, []);

  if (loading) {
    return <Spinner />;
  } else {
    return (
      <>
        <div className="h-100">
          <Helmet>
            <title>
              {companyName.companyName} | {t("Sidemenu.rankIncentive")}
            </title>
          </Helmet>
          <div className={style.MainContainer}>
            {error && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "80vh",
                }}
              >
                <h6>{error}</h6>
              </div>
            )}

            <div
              className={`${
                currentTheme == "theme-dark"
                  ? `${style.dark_mode_dashboard_pannel_box}`
                  : `${style.dashboard_pannel_box}`
              }`}
            >
              <Table style={{ padding: "5px !important" }}>
                <TableHead style={{ padding: "5px !important" }}>
                  <TableRow>
                    <TableCell
                      style={{
                        fontSize: "14px",
                        fontWeight: "bold",
                        width: "30%",
                        padding: "5px",
                      }}
                    >
                      Rank
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: "14px",
                        fontWeight: "bold",
                        width: "20%",
                        padding: "5px",
                      }}
                    >
                      Incentive
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: "14px",
                        fontWeight: "bold",
                        width: "20%",
                        padding: "5px",
                      }}
                    >
                      Date Earned
                    </TableCell>
                  </TableRow>
                </TableHead>
                {state.length > 0 && (
                  <TableBody style={{ backgroundColor: "white" }}>
                    {state.map((items) => (
                      <TableRow key={items.title}>
                        <TableCell style={{ padding: "5px" }}>
                          <div
                            style={
                              {
                                // display: "flex",
                                // alignItems: "center",
                                // width: "200px",
                              }
                            }
                          >
                            <span
                              style={{
                                fontSize: "11px",
                                fontWeight: "normal",
                                position: "relative",
                                marginLeft: "5px",
                                padding: "1px",
                              }}
                            >
                              {/* ⚪{" "} */}
                              {items.rank
                                .toLowerCase()
                                .replace(/^(.)|\s(.)/g, (letter) =>
                                  letter.toUpperCase()
                                )}
                            </span>
                          </div>
                        </TableCell>

                        <TableCell style={{ width: "20%", padding: "5px" }}>
                          {Currency.currentCurr}
                          {items.incentive}
                        </TableCell>
                        <TableCell style={{ width: "20%", padding: "5px" }}>
                          {moment
                            .utc(items.date)
                            .subtract(8, "hours")
                            .tz("Asia/Manila")
                            .format("MM/DD/YYYY h:mm:ss A")}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                )}
              </Table>
            </div>

            {!loading && state.length == 0 && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "80vh",
                }}
              >
                <h6>EMPTY</h6>
              </div>
            )}
          </div>
        </div>
      </>
    );
  }
}
export default withTranslation()(withRouter(RankIncentive));
